// core
import { Injectable } from '@angular/core';

// services
import { RaptorApiService } from './raptor-api.service';

@Injectable({
  providedIn: 'root'
})
export class RaptorGocardlessService extends RaptorApiService {

  createAccount(payload: any): Promise<any> {
    return this.post('/payment/direct_debit', payload).toPromise();
  }

  confirmPayment(payload: any): Promise<any> {
    return this.post('/payment/confirm_direct_debit', payload).toPromise();
  }
}
